import { render, staticRenderFns } from "./SelectDepot.vue?vue&type=template&id=2ab13137&lang=html&"
import script from "./SelectDepot.vue?vue&type=script&lang=js&"
export * from "./SelectDepot.vue?vue&type=script&lang=js&"
import style0 from "./SelectDepot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports